export default __webpack_public_path__ + "static/cardsRowImg1-9243b80a276261b32b48bb72f9337327.png";